import React from 'react';

import { Grid, Box, Typography } from '@mui/material';
import { styled } from '@mui/system';
import LanguageHandler from '../LanguageHandler';

const AppBar = styled(Grid)(() => ({
  display: 'flex',
  position: 'fixed',
  backgroundColor: 'rgba(255,255,255,0.9)',
  backdropFilter: 'blur(12px)',
  zIndex: '100',
  top: '0px',
  width: '100%',
  justifyContent: 'space-between',
  padding: '12px 16px',
  borderBottom: '1px solid #E2E8F0',
  '& label': {
    color: '#0F172A',
    fontSize: '16px',
  },
}));

const Title = styled(Typography)(() => ({
  fontSize: '1.1em',
  fontWeight: '700',
  fontFamily: '"Outfit", "DM Sans", sans-serif',
  color: '#0D9488',
  letterSpacing: '-0.02em',
  display: 'inline-block',
}));

function LoginNavbar() {
  return (
    <AppBar item xs={12} alignItems="center">
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box
          component="img"
          sx={{
            height: 32,
            width: 32,
            marginRight: 1,
          }}
          alt=""
          src="/icon-192x192.png"
        />

        <Title
          variant="h6"
          component={'span'}
          noWrap
        >
          Commit2Act
        </Title>
      </Box>
      <div>
        <LanguageHandler />
      </div>
    </AppBar>
  );
}

export default LoginNavbar;
